import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/CookieAuth/auth.service';
import { Usr } from 'src/app/interfaces/usr';
import { UsuarioService } from 'src/app/service/usuario.service';
import { UsuarioFormComponent } from '../usuario-form/usuario-form.component';

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.css']
})
export class PersonalComponent implements OnInit {
public usuarios?:any[];
  constructor(private cookie: AuthService, private dialog: MatDialog, private usuariosService: UsuarioService) {

    this.cargaItm();
   }

  ngOnInit(): void {
    // this.cargaItm();

  }

  private cargaItm(){
    this.usuariosService.get().subscribe((item:Usr[])=>{
      this.usuarios=item;
    });
  }

  abrirUsr(id:number){
    let dialogRef = this.dialog.open(UsuarioFormComponent, {
      data: {id: id},
      maxHeight: '90vh'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      this.cargaItm();

    });

    console.log(id);
  }

}
